<template>
	<Bar :data="data" :options="horizontalOptions" />
</template>

<script>
import { Bar } from 'vue-chartjs'
import { useChart } from '@/composables/useChart'

export default {
	name: 'HorizontalBar',
	props: {
		data: {
			type: Object,
			required: true
		},
		options: {
			type: Object,
			default: () => ({})
		}
	},
	components: { Bar },
	setup () {
		useChart()
	},
	computed: {
		horizontalOptions() {
			return {
				indexAxis: 'y',
				responsive: true,
				maintainAspectRatio: false,
				...this.options
			}
		}
	}
}
</script>

<style scoped>

</style>
